import { GOOGLE_REVIEWS_URL, GOOGLE_REVIEW_COUNT, PARENT_BRAND } from "@/lib/brand";

/** Hero trust line: Google rating + the Empress Elite Limousine connection (on dark photos). */
export default function BrandLine({ className = "" }: { className?: string }) {
  return (
    <p className={`mt-6 text-white/85 text-xs sm:text-sm font-medium tracking-wide ${className}`}>
      <span className="text-gold tracking-[0.15em] mr-1.5" aria-label="5 stars">★★★★★</span>
      <a
        href={GOOGLE_REVIEWS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="underline underline-offset-4 decoration-white/40 hover:text-white"
      >
        5.0 on Google, {GOOGLE_REVIEW_COUNT} reviews
      </a>
      <span className="block sm:inline sm:before:content-['·'] sm:before:mx-2 mt-1 sm:mt-0">
        The luxury Sprinter fleet of {PARENT_BRAND}
      </span>
    </p>
  );
}
